//import "./wdyr";
import React from "react";
import { render } from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import App from "./App";
import ErrorHandler from "./components/ErrorHandler/ErrorHandler";
import AFrameConontrollApp from "./components/AFrameControlApp";
import AutoStoreControlApp from "./components/AutoStoreControlApp/AutoStoreControlApp";
import BoxReview from "./components/BoxReview/BoxReview";
import Settings from "./components/Settings/Settings";
import ConnectionError from "./ConnectionError";
import DoubleWindowError from "./DoubleWindowError";
import * as serviceWorker from "./serviceWorker";

import { SignalR } from "./utils/SignalRUtil";
import { BASE_ROUTER_ROUTE, RUN_SIGNALR } from "./utils/Constants";
import * as UtilMethods from "./utils/UtilMethods";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./lib/store/storeConfig";
import { storeRegistry } from "./lib/store/storeRegistry";

import WorkstationEndpoints from "./lib/workstation/WorkstationEndpoints";
import RxBoxApp from "./components/RxBoxApp/rxBoxApp";
import rxBoxAppWest from "./components/RxBoxApp/rxBoxAppWest";
import RxBoxAppWest from "./components/RxBoxApp/rxBoxAppWest";
import ControlApp from "./components/ControlApp/ControlApp";
import CheckStationHubContextProvider, {
  CheckStationHubContext,
} from "./context/CheckStationHubContext";
import ShippingOverview from "./components/ControlApp/ShippingOverview/ShippingOverview";
import OrderOverview from "./components/ControlApp/OrderOverview/OrderOverview";

if (process.env.NODE_ENV !== "development") {
  document.oncontextmenu = () => false;
}

//const appStore = createStore(reducersComposite, {}, applyMiddleware(createLogger()));
const appRootDOMContainer = document.getElementById("root");
storeRegistry.register(store);

const renderApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <App />
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderError = () => render(<ConnectionError />, appRootDOMContainer),
  renderReviewApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <BoxReview />
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderSettingsApp = (loginKey) => render(<Settings loginKey={loginKey} />, appRootDOMContainer),
  renderDoubleWindowError = () => render(<DoubleWindowError />, appRootDOMContainer),
  renderRxApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <RxBoxApp></RxBoxApp>
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderRxWestApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <RxBoxAppWest></RxBoxAppWest>
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderAFrameControlApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <AFrameConontrollApp></AFrameConontrollApp>
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderControlApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <CheckStationHubContextProvider>
              {/* <BrowserRouter basename={BASE_ROUTER_ROUTE}>
                <Routes>
                  <Route path="/" element={<ControlApp />} />
                </Routes>
              </BrowserRouter> */}
              <ControlApp />
            </CheckStationHubContextProvider>
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    ),
  renderAutoStoreControlApp = () =>
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorHandler>
            <AutoStoreControlApp></AutoStoreControlApp>
          </ErrorHandler>
        </PersistGate>
      </Provider>,
      appRootDOMContainer
    );

const params = UtilMethods.GetUrlParams();
const rbParam = params["review"];
const stParam = params["settings"];
const dwErrParam = params["dwerror"];
const aframeParam = params["aframe"];
const autostoreParam = params["autostore"];
const rxModeParam = params["rx"];
const rxWestModeParam = params["rxwest"];
const branchID = UtilMethods.branchID;

if (branchID === 20) {
  renderControlApp();
} else if (rbParam && rbParam.length && rbParam[0] === "1") {
  renderReviewApp();
} else if (aframeParam && aframeParam.length && aframeParam[0]) {
  renderAFrameControlApp();
} else if (autostoreParam && autostoreParam.length && autostoreParam[0]) {
  renderAutoStoreControlApp();
} else if (rxModeParam && rxModeParam.length && rxModeParam[0]) {
  renderRxApp();
} else if (rxWestModeParam && rxWestModeParam.length && rxWestModeParam[0]) {
  renderRxWestApp();
} else if (stParam && stParam.length && stParam[0]) {
  let loginKey = params["lk"];
  loginKey = (loginKey && loginKey.length && loginKey[0]) || "";
  renderSettingsApp(loginKey);
} else if (dwErrParam && dwErrParam.length && dwErrParam[0]) {
  renderDoubleWindowError();
} else if (RUN_SIGNALR) {
  let workstationID = UtilMethods.getParamValue("ws");

  WorkstationEndpoints.getWorkstationInformation(workstationID).then((wsResult) => {
    if (!UtilMethods.IsManualPack(wsResult.workstationType)) {
      SignalR.downloadHubProxies()
        .then(renderApp)
        .catch(() => {
          renderError();
          SignalR.downloadHubProxies(true).then(renderApp);
        });
    } else {
      renderApp();
    }
  });
} else {
  renderApp();
}

serviceWorker.unregister();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
